import { useCallback, useEffect, useState } from "react";
import ReportPresenter from "./ReportPresenter";
import * as s from "./ReportStyled";
import TableButton from "components/atoms/buttons/TableButton";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import {
  CPReport,
  CPReportDataRow,
  CVVReport,
  GetReportListResposne,
  InstallReport,
  ReportDataRow,
  ThumbnailReport,
} from "api/interfaces/reportInterface.interface";
import {
  changeTypeForReportType,
  changeTypeNumberForReportText,
  formatNumber,
} from "utils/functions";
import TableColumnFilterTitle from "components/blocks/table/TableColumnFilterTitle";
import {
  BasePagination,
  DefaultQueryParam,
  LEVEL_TYPE,
  SORT_DIRECTION,
} from "api/interfaces/commonInterface.interface";
import { useQuery } from "react-query";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import {
  getReportInfo,
  getReportInfoCP,
  getReportInfoCVV,
  getReportInfoInstall,
  getReportInfoThumbnail,
  getReportList,
} from "api/reportAPI";
import { getAccountTimeFormat } from "utils/timeUtil";
import DetailButton from "components/atoms/buttons/detail/DetailButton";
import RBACWrapper from "components/blocks/function/RBACWrapper";
import {
  HealthReport,
  InventoryReport,
} from "api/interfaces/reportInterface.interface";
import { isCheckPermission } from "utils/AccountUtil";
import { isNull } from "lodash";
import { TableColumnsType } from "antd";
import { ColumnType } from "antd/es/table";
import {
  changeSortOrderAntd,
  onSortAntd,
} from "components/atoms/table/AntdTable";
import * as mediaQuery from "components/MediaQuery";
import { FaInfoCircle } from "react-icons/fa";
import { AddReportListType } from "./add/AddReport";
import { Row } from "pages/users/UsersStyled";
import useStompDebouncedRefetch from "hook/useStompDebouncedRefetch";
import { WithTooltip } from "components/blocks/WithTooltip";
import { baseQueryInfo, useQueryKey } from "utils/queryUtil";
import { useMenu } from "hook/useMenu";
import useApiError from "hook/useApiError";
export interface DataRow {
  type: string;
  title: string;
  recorder: string;
  createdBy: string;
  email: string;
  createdAt: string;
  enable: boolean;
  accountName: string;
  accountNumber: string;
  recorderTotalCount: number;
}

const initialDetailCP = [
  {
    name: "health",
    value: 0,
    label: "Health",
  },
  {
    name: "inventory",
    value: 0,
    label: "Inventory",
  },
  {
    name: "installation",
    value: 0,
    label: "Installation",
  },
];

const initialDetailEU = [
  {
    name: "health",
    value: 0,
    label: "Health",
  },
  {
    name: "cvv",
    value: 0,
    label: "CVV",
  },
  // {
  //   name: "thumbnail",
  //   value: 0,
  //   label: "Thumbnail",
  // },
  {
    name: "inventory",
    value: 0,
    label: "Inventory",
  },
  {
    name: "installation",
    value: 0,
    label: "Installation",
  },
];

const typeFiltersCP = [
  {
    label: "Health",
    value: "health",
  },
  {
    label: "Inventory",
    value: "inventory",
  },
  {
    label: "Installation",
    value: "installation",
  },
];

const typeFiltersEU = [
  {
    label: "Health",
    value: "health",
  },
  {
    label: "CVV",
    value: "cvv",
  },
  // {
  //   label: "Thumbnail",
  //   value: "thumbnail",
  // },
  {
    label: "Inventory",
    value: "inventory",
  },
  {
    label: "Installation",
    value: "installation",
  },
];

const initialReportQueryInfo: BasePagination = {
  ...baseQueryInfo,
  sortType: "createdAt",
  sortDirection: SORT_DIRECTION.DESC,
  type: null,
};

export default function ReportContainer(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const isBigScreen = mediaQuery.useIsBigScreen();

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { lang, notifyError } = useApiError();

  const [isRowClickEditable, setIsRowClickEditable] = useState<boolean>(
    isCheckPermission("manageReportRules", selectedAccount)
  );
  const { queryNavigate, returnToStartPage } = useMenu({});

  useEffect(() => {
    if (selectedAccount) {
      setIsRowClickEditable(
        isCheckPermission("manageReportRules", selectedAccount)
      );
    }
  }, [selectedAccount]);

  const [selectReportRow, setSelectReportRow] = useState<
    ReportDataRow | CPReportDataRow
  >();

  const [selectData, setSelectData] = useState<
    | HealthReport
    | InventoryReport
    | InstallReport
    | CVVReport
    | ThumbnailReport
    | CPReport
  >();
  const isMobile = mediaQuery.useIsMobile();

  const onRowClick = (row: ReportDataRow | CPReportDataRow) => {
    if (selectedAccount.accountLevel === LEVEL_TYPE.CP) {
      onClickCPEdit(row as CPReportDataRow);
      return;
    }
    onViewDetail(row);
  };

  const onViewDetail = ({ type, id }: { type: string; id: string }) => {
    queryNavigate({
      to: `/reports/${changeTypeNumberForReportText(type)}/${id}`,
      queryInfo: {} as DefaultQueryParam,
    });
  };

  const [reportList, setReportList] = useState<
    ReportDataRow[] | CPReportDataRow[]
  >([]);
  const [totalCount, setTotalCount] = useState(0);
  const [detailItems, setDetailItems] = useState<
    { name: string; value: number; label: string }[]
  >(
    selectedAccount.accountLevel === LEVEL_TYPE.CP
      ? initialDetailCP
      : initialDetailEU
  );

  const [reportQueryInfo, setReportQueryInfo] = useState<BasePagination>({
    ...initialReportQueryInfo,
  });
  const queryKey = useQueryKey(reportQueryInfo);

  const status = {
    totalTitle: "Total",
    totalValue: totalCount,
    items:
      selectedAccount.accountLevel === LEVEL_TYPE.EU
        ? [
            <DetailButton
              title={"Report Quantities by category"}
              contents={detailItems}
            />,
          ]
        : [],
  };

  useEffect(() => {
    if (!selectedAccount.userPermission.viewReports) {
      returnToStartPage();
    }
  }, [selectedAccount.userPermission.viewReports]);

  useEffect(() => {
    const changeParam = new URLSearchParams(location.search);
    if (changeParam.size > 0) {
      // console.log(changeParam.get("pageNum"));
      setReportQueryInfo((info) => {
        return {
          ...info,
          pageNum: isNull(changeParam.get("pageNum"))
            ? initialReportQueryInfo.pageNum
            : Number(changeParam.get("pageNum")),
          pageLimit: isNull(changeParam.get("pageLimit"))
            ? initialReportQueryInfo.pageLimit
            : Number(changeParam.get("pageLimit")),
          keyword: isNull(changeParam.get("keyword"))
            ? initialReportQueryInfo.keyword
            : (changeParam.get("keyword") as string),
          sortType: isNull(changeParam.get("sortType"))
            ? initialReportQueryInfo.sortType
            : (changeParam.get("sortType") as string),
          sortDirection: isNull(changeParam.get("sortDirection"))
            ? initialReportQueryInfo.sortDirection
            : (changeParam.get("sortDirection") as SORT_DIRECTION),
          type: isNull(changeParam.get("type"))
            ? initialReportQueryInfo.type
            : (changeParam.get("type") as string),
        };
      });
    } else {
      setReportQueryInfo({ ...initialReportQueryInfo });
    }
  }, [location, navigate]);

  const onChangeReportType = useCallback(
    (value: string | undefined) => {
      if (value === "all" || !value) {
        queryNavigate({
          to: location.pathname,
          queryInfo: {
            ...reportQueryInfo,
            pageNum: 0,
            type: null,
          },
        });
      } else {
        queryNavigate({
          to: location.pathname,
          queryInfo: {
            ...reportQueryInfo,
            pageNum: 0,
            type: value,
          },
        });
      }
    },
    [location.pathname, queryNavigate, reportQueryInfo]
  );
  const onHeaderCell = (
    column: ColumnType<ReportDataRow> | ColumnType<CPReportDataRow>
  ) => {
    return {
      onClick: () => {
        if (column.key) {
          queryNavigate({
            to: location.pathname,
            queryInfo: {
              ...reportQueryInfo,
              pageNum: 0,
              sortType: column.key as string,
              sortDirection: onSortAntd(reportQueryInfo.sortDirection),
            },
          });
        }
      },
    };
  };
  // table columns
  const columns: TableColumnsType<ReportDataRow> = [
    {
      title: (
        <TableColumnFilterTitle
          title="Type"
          filters={
            selectedAccount.accountLevel === LEVEL_TYPE.CP
              ? typeFiltersCP
              : typeFiltersEU
          }
          onClick={onChangeReportType}
          data-testid="reports-table-column-filter-report-type"
        />
      ),

      render: (value, row) => (
        <Row isAdmin={row.isDefault}>{changeTypeForReportType(row.type)}</Row>
      ),

      width: 120,
    },
    {
      title: "Title",
      sorter: true,
      key: "title",
      sortOrder: changeSortOrderAntd(reportQueryInfo, "title"),
      onHeaderCell: onHeaderCell,
      render: (value, row) => <Row isAdmin={row.isDefault}>{row.title}</Row>,
      width: isMobile ? undefined : "20%",
    },
    {
      title: "Recorder",
      render: (value, row, index) => (
        <s.RecorderRow status={row.recorderTotalCount > 0 ? true : false}>
          {row.recorder}
          {row.type === "INSTALLATION" &&
            row.systems === undefined &&
            row.installationRecorder !== undefined &&
            row.recorderTotalCount === 0 && (
              <mediaQuery.Default>
                <WithTooltip tooltip="No longer available in the organization.">
                  <FaInfoCircle />
                </WithTooltip>
              </mediaQuery.Default>
            )}
        </s.RecorderRow>
      ),

      responsive: ["md"],
    },
    {
      title: "Created By",
      sorter: true,
      sortOrder: changeSortOrderAntd(reportQueryInfo, "createdBy"),
      key: "createdBy",
      onHeaderCell: onHeaderCell,
      render: (value, row) =>
        row.createdBy +
        (isBigScreen && row.createdBy !== "System" ? ` (${row.email})` : ""),
      responsive: ["xl"],
      width: isBigScreen ? "20%" : 200,
    },
    {
      title: "Date Created",
      sorter: true,
      key: "createdAt",
      defaultSortOrder: "ascend",
      sortOrder: changeSortOrderAntd(reportQueryInfo, "createdAt"),
      onHeaderCell: onHeaderCell,
      render: (value, row) =>
        row.createdAt !== undefined
          ? getAccountTimeFormat(row.createdAt, selectedAccount, true)
          : "",
      width: isBigScreen ? "20%" : 200,
      responsive: ["lg"],
    },
    // 마지막 버튼
    {
      title: "",
      render: (value, row, index) => (
        <s.Row className="table-button-wrapper">
          {row.type !== "INSTALLATION" && (
            <RBACWrapper requiredPermissions="manageReportRules">
              <TableButton
                label="Edit"
                onClick={(e) => {
                  e.stopPropagation();
                  onClickEdit(row);
                }}
                data-testid={`reports-table-button-edit-${index}`}
              />
            </RBACWrapper>
          )}

          <span className="row-click-button">
            <TableButton
              label="View"
              onClick={() => onViewDetail(row)}
              disabled={
                row.type !== "INSTALLATION" && row.recorderTotalCount === 0
              }
              data-testid={`reports-table-button-view-detail-${index}`}
            />
          </span>
        </s.Row>
      ),

      align: "right",
      width: isMobile ? 50 : 150,
    },
  ];

  const onClickEdit = (row: ReportDataRow) => {
    // console.log(row);
    const reportTypeString: AddReportListType = changeTypeNumberForReportText(
      row.type
    );
    setSelectReportRow((report) => {
      return row;
    });

    switch (reportTypeString) {
      case "health":
      case "inventory":
        getReportInfo({
          accountId: selectedAccount.accountId,
          reportId: row.id,
        }).then((res: any) => {
          if (res.result !== undefined && res.error === 0) {
            setSelectData((data) => {
              return res.result as HealthReport;
            });
            onModal("edit");
          }
        }).catch(() => {});
        break;
      case "cvv":
        getReportInfoCVV({
          accountId: selectedAccount.accountId,
          reportId: row.id,
        }).then((res: any) => {
          if (res.result !== undefined && res.error === 0) {
            setSelectData((data) => {
              return res.result as CVVReport;
            });
            onModal("edit");
          }
        }).catch(() => {});
        break;
      case "thumbnail":
        getReportInfoThumbnail({
          accountId: selectedAccount.accountId,
          reportId: row.id,
        }).then((res: any) => {
          if (res.result !== undefined && res.error === 0) {
            setSelectData((data) => {
              return res.result as ThumbnailReport;
            });
            onModal("edit");
          }
        }).catch(() => {});
        break;
      case "installation":
        getReportInfoInstall({
          accountId: selectedAccount.accountId,
          reportId: row.id,
        }).then((res: any) => {
          if (res.result !== undefined && res.error === 0) {
            setSelectData((data) => {
              return res.result as InstallReport;
            });
            onModal("edit");
          }
        }).catch(() => {});
        break;
      default:
        break;
    }
  };

  const cpColumns: TableColumnsType<CPReportDataRow> = [
    {
      title: "Title",
      sorter: true,
      key: "title",
      sortOrder: changeSortOrderAntd(reportQueryInfo, "title"),
      onHeaderCell: onHeaderCell,
      render: (value, row) => <Row isAdmin={row.isDefault}>{row.title}</Row>,
    },

    {
      title: "Organizations",
      render: (value, row) => {
        if (row.type === "INSTALLATION") {
          return (
            <s.RecorderRow status={row.accountCount > 0} level={LEVEL_TYPE.CP}>
              {row.accounts?.map((account) => account.accountName).join("")}
              {row.accountCount === 0 && (
                <mediaQuery.Default>
                  <WithTooltip
                    tooltip={"No longer available the organization."}
                  >
                    <FaInfoCircle />
                  </WithTooltip>
                </mediaQuery.Default>
              )}
            </s.RecorderRow>
          );
        }
        return formatNumber(row.accountCount);
      },
      align: "center",
      width: "10%",
      responsive: ["lg"],
    },
    {
      title: "Recorders",
      render: (value, row) => {
        if (row.type === "INSTALLATION") {
          return row.systems ? (
            <s.RecorderRow
              status={row.recorderTotalCount > 0 ? true : false}
              level={LEVEL_TYPE.CP}
            >
              {row.systems[0]?.mergedSystemName}
              {row.systems.length > 1 ? ` + ${row.systems.length - 1}` : ""}
              {row.recorderTotalCount === 0 && (
                <mediaQuery.Default>
                  <WithTooltip tooltip="No longer available in the organization.">
                    <FaInfoCircle />
                  </WithTooltip>
                </mediaQuery.Default>
              )}
            </s.RecorderRow>
          ) : (
            formatNumber(row.recorderCount)
          );
        }
        return formatNumber(row.recorderCount);
      },
      align: "center",
      width: "10%",
      responsive: ["lg"],
    },
    {
      title: "Cameras",
      render: (value, row) => formatNumber(row.cameraCount),
      align: "center",
      width: "10%",
      responsive: ["lg"],
    },
    {
      title: "Created By",
      sorter: true,
      sortOrder: changeSortOrderAntd(reportQueryInfo, "createdBy"),
      key: "createdBy",
      onHeaderCell: onHeaderCell,
      render: (value, row) =>
        row.createdBy +
        (isBigScreen && row.createdBy !== "System" ? ` (${row.email})` : ""),
      responsive: ["xxl"],
      width: isBigScreen ? "20%" : 200,
    },
    {
      title: "Date Created",
      sorter: true,
      key: "createdAt",
      defaultSortOrder: "ascend",
      sortOrder: changeSortOrderAntd(reportQueryInfo, "createdAt"),
      onHeaderCell: onHeaderCell,
      render: (value, row) =>
        row.createdAt
          ? getAccountTimeFormat(row.createdAt, selectedAccount, true)
          : "",
      responsive: ["xl"],
      width: 200,
    },

    {
      title: "",
      render: (value, row, index) =>
        row.type === "CP" ? (
          <s.Row className="table-button-wrapper">
            <TableButton
              label="Inventory"
              onClick={() => onViewDetail({ type: "INVENTORY", id: row.id })}
              disabled={row.accountCount === 0 || row.recorderCount === 0}
              data-testid={`reports-table-button-view-inventory-${index}`}
            />

            <TableButton
              label="Health"
              onClick={() => onViewDetail({ type: "HEALTH", id: row.id })}
              disabled={row.accountCount === 0 || row.recorderCount === 0}
              data-testid={`reports-table-button-view-health-${index}`}
            />

            <RBACWrapper requiredPermissions="manageReportRules">
              <span className="row-click-button">
                <TableButton
                  label="Edit"
                  onClick={() => onClickCPEdit(row)}
                  data-testid={`reports-table-button-edit-${index}`}
                />
              </span>
            </RBACWrapper>
          </s.Row>
        ) : (
          <s.Row className="table-button-wrapper">
            <TableButton
              label="Installation"
              icon={
                row.isUpdatable ? (
                  <WithTooltip tooltip="In-Progress">
                    <FaInfoCircle />
                  </WithTooltip>
                ) : undefined
              }
              onClick={() => onViewDetail({ type: "INSTALLATION", id: row.id })}
              disabled={row.accountCount === 0}
              data-testid={`reports-table-button-view-installation-${index}`}
            />

            <RBACWrapper requiredPermissions="manageReportRules">
              <span className="row-click-button">
                <TableButton
                  label="Edit"
                  onClick={() => onClickEdit(row as unknown as ReportDataRow)}
                  data-testid={`reports-table-button-edit-${index}`}
                />
              </span>
            </RBACWrapper>
          </s.Row>
        ),

      align: "right",
      width: isMobile ? 100 : 280,
    },
  ];

  const onClickCPEdit = (row: CPReportDataRow) => {
    setSelectReportRow({ ...row });
    getReportInfoCP({
      accountId: selectedAccount.accountId,
      reportId: row.id,
    }).then((res: any) => {
      if (res.result !== undefined && res.error === 0) {
        setSelectData((data) => {
          return res.result as CPReport;
        });
        onModal("edit");
      }
    });
  };

  const onSuccessDelete = () => {
    queryNavigate({
      to: location.pathname,
      queryInfo: {
        ...initialReportQueryInfo,
      },
    });
  };

  const onModal = (type?: string) => {
    if (type === "add") {
      setIsAddModal(!isAddModal);
    }
    if (type === "edit") {
      setIsEditModal(!isEditModal);
    }
  };

  const [isAddModal, setIsAddModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);

  const displayRecorder = (
    systems: any[],
    recorderGroup: any[],
    recorderTotalCount: number,
    type: string,
    installationRecorder?: string
  ) => {
    let name = "";
    let count = recorderTotalCount;
    let mergedCount = 0;

    if (systems !== undefined && systems.length > 0) {
      mergedCount += systems.length;
      systems.forEach((merged: any) => {
        if (merged.recorders !== undefined) {
          if (name === "") {
            if (type !== "INSTALLATION") {
              name = merged.mergedSystemName;
            } else {
              if (
                merged.recorders !== undefined &&
                merged.recorders.length > 0
              ) {
                name = merged.recorders[0].name;
              }
            }
          }
        }
      });
    }

    if (recorderGroup !== undefined && recorderGroup.length > 0) {
      recorderGroup.forEach((group: any) => {
        mergedCount += group.recorderCount;
        if (group.systems !== undefined && group.systems.length > 0) {
          group.systems.forEach((merged: any) => {
            if (name === "") {
              name = merged.mergedSystemName;
            }
          });
        }
      });
    }

    // installation deleted
    if (type === "INSTALLATION") {
      if (systems === undefined && installationRecorder !== undefined) {
        count = 1;
        name = `${installationRecorder}`;
      }
    }
    return count === 0
      ? "No Recorder"
      : count === 1 || mergedCount === 1
      ? name
      : name + `+${count - 1}`;
  };

  const { isLoading, refetch, isSuccess, isFetching } = useQuery(
    ["reportList", queryKey, selectedAccount.accountId],
    () =>
      getReportList({
        payload: reportQueryInfo,
        accountId: selectedAccount.accountId,
      }),
    {
      retry: 0,
      refetchOnWindowFocus: false,
      onSuccess: (res: GetReportListResposne) => {
        setReportQueryInfo({ ...reportQueryInfo, ...res.page });
        // console.log(res);
        if (!res.result || res.page?.total === 0) {
          setTotalCount(0);
          setDetailItems(
            selectedAccount.accountLevel === LEVEL_TYPE.CP
              ? initialDetailCP
              : initialDetailEU
          );
          setReportList([]);

          return;
        }
        setTotalCount(res.page.total);

        if (selectedAccount.accountLevel === LEVEL_TYPE.EU) {
          setDetailItems(
            initialDetailEU.map((item) => {
              if (Array.isArray(res?.result?.typeInfos)) {
                for (const typeInfo of res.result.typeInfos || []) {
                  if (item.name === (typeInfo.type || "").toLowerCase()) {
                    return { ...item, value: typeInfo.typeCount };
                  }
                }
              }
              return {
                ...item,
              };
            })
          );

          if (res.result.reports) {
            setReportList(
              res.result.reports.map((report: any) => {
                // console.log(report);
                return {
                  ...report,
                  recorder: report.autoApply
                    ? "ALL"
                    : displayRecorder(
                        report.systems,
                        report.recorderGroups,
                        report.recorderTotalCount,
                        report.type,
                        report.installationRecorder
                      ),

                  enable: report.isEnable,
                  key: report.id,
                };
              })
            );
          }

          return;
        }

        setReportList(
          res.result.reports.map((report) => ({
            ...report,
            key: report.id,
          })) as CPReportDataRow[]
        );
      },
      onError: (e: any) => {
        setReportQueryInfo({ ...initialReportQueryInfo });
        setDetailItems(
          selectedAccount.accountLevel === LEVEL_TYPE.CP
            ? initialDetailCP
            : initialDetailEU
        );
        setReportList([]);
        notifyError(lang.label.report.notify.list.search.fail);
      },
    }
  );

  useStompDebouncedRefetch({
    stompKey: "reportListUpdated",
    refetch,
    enabled: isSuccess,
  });

  const onClickSearch = useCallback(
    (keyword: string) => {
      queryNavigate({
        to: location.pathname,
        queryInfo: {
          ...reportQueryInfo,
          pageNum: 0,
          keyword: keyword,
        },
      });
    },
    [location.pathname, queryNavigate, reportQueryInfo]
  );

  const onChangePage = useCallback(
    (page: number, totalRows: number) => {
      if (page !== reportQueryInfo.pageNum + 1) {
        queryNavigate({
          to: location.pathname,
          queryInfo: {
            ...reportQueryInfo,
            pageNum: page - 1,
          },
        });
      }
    },
    [location.pathname, queryNavigate, reportQueryInfo]
  );

  return (
    <ReportPresenter
      columns={columns}
      cpColumns={cpColumns}
      data={reportList}
      onModal={onModal}
      isAddModal={isAddModal}
      isEditModal={isEditModal}
      status={status}
      onRowClick={onRowClick}
      selectReportRow={selectReportRow}
      selectData={selectData}
      selectedAccount={selectedAccount}
      paginationInfo={reportQueryInfo}
      onChangePage={onChangePage}
      onClickSearch={onClickSearch}
      isRowClickEditable={isRowClickEditable}
      tablePending={isLoading}
      onSuccessDelete={onSuccessDelete}
    />
  );
}
